import React, { useMemo } from 'react';
import { Avatar, Flexbox, Text } from '@sonika-se/ui-kit/components';
import { graphql, useFragment } from 'react-relay/hooks';
import getAssignedEntityAvatarProps from '~/utils/getAssignedEntityAvatarProps';
import getAssignedEntityText from '~/utils/getAssignedEntityText';
export const SchedulableEntityWithText = (props) => {
    var _a;
    const { children, iScheduleableEntityRef, onClick, appearance = 'round', childTextProps, isVacant, size = 'small', shiftStatus, } = props;
    const data = useFragment(graphql `
      fragment SchedulableEntityWithText_iScheduleableEntity on ISchedulableEntity {
        id
        displayName
        color
        ... on SchedulableUser {
          user {
            employeeId
          }
        }
      }
    `, iScheduleableEntityRef);
    const avatarProps = useMemo(() => getAssignedEntityAvatarProps(isVacant, shiftStatus, data === null || data === void 0 ? void 0 : data.displayName, data === null || data === void 0 ? void 0 : data.color), [data, isVacant, shiftStatus]);
    const displayText = useMemo(() => getAssignedEntityText(isVacant, shiftStatus, data === null || data === void 0 ? void 0 : data.displayName), [data, isVacant, shiftStatus]);
    const employeeId = data && 'user' in data ? (_a = data.user) === null || _a === void 0 ? void 0 : _a.employeeId : null;
    const showEmployeeId = !isVacant && shiftStatus !== 'WITHDRAWN' && employeeId;
    return (<div onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <Flexbox align="start" gap="xsmall" style={{ marginTop: '.25rem' }}>
        <Avatar appearance={appearance} size={size} {...avatarProps}/>
        <div>
          <Text>
            {displayText}
            {showEmployeeId && (<span style={{ color: '#888', fontSize: '0.875em', fontWeight: 'normal', marginLeft: '0.25em' }}>
                #{employeeId}
              </span>)}
          </Text>
          <Text {...childTextProps} style={{ color: '#484848' }}>
            {children}
          </Text>
        </div>
      </Flexbox>
    </div>);
};
export default SchedulableEntityWithText;
